import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import { postStoreCustomerIdConfig } from "../../../services/StoreCustomerId/StoreCustomerId";

const StoreCustomerIdConfigAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, item, StoreData } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;


  const [isUpdating, setIsUpdating] = useState(item?.id);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);
 
  const [input, setInput] = useState({
    prefix: "",
    lastCustomerId: "",
    postfix: "",
  });

  useEffect(() => {
     if (item) {
    setInput((prevState) => ({
      ...prevState,
      postfix: item?.postfix || "",
      lastCustomerId: item?.lastCustomerId || "",
      prefix: item?.prefix || "",
    }));
  }
  }, [item]);

  const [prefixError, setPrefixError] = useState("");
  const [lastCustomerIdError, setLastCustomerIdError] = useState("");
  const [postfixError, setPostfixError] = useState("");
  
  const handleSubmit = () => {
    // Reset all previous errors

    // setPrefixError("");
    setLastCustomerIdError("");
    // setPostfixError(""); 
   

    let isValid = true;
    // if (!input.prefix) {
    //   setPrefixError("Prefix is Required");
    //   isValid = false;
    // }
    if (!input.lastCustomerId) {
      setLastCustomerIdError("Last Customer Id is Required");
      isValid = false;
    }
    // if (!input.postfix) {
    //   setPostfixError("Postfix is Required");
    //   isValid = false;
    // }
     

    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          ...item,
          storeId: id,
          prefix: input.prefix,
          lastCustomerId: input.lastCustomerId,
          postfix: input.postfix,
        };

        // Call the service function for creating pickup request

          postStoreCustomerIdConfig(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/store-customer-id-config-List", {
                        state: {
                          id: id,
                          StoreData: StoreData,
                        },
                      });
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/store-customer-id-config-List", {
                        state: {
                          id: id,
                          StoreData: StoreData,
                        },
                      })}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Customer Id {item?.id ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="name"
              value={input.prefix}
              onChange={(e) => {
                setInput({
                  ...input,
                  prefix: e.target.value,
                });
                // setPrefixError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {/*prefixError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {prefixError}
              </p>
            )*/}

            <label
              htmlFor="prefix"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Prefix 
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="lastCustomerId"
              value={input.lastCustomerId}
              onChange={(e) => {
                setInput({
                  ...input,
                  lastCustomerId: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              disabled={item?.id ? true : false}
            />
            {lastCustomerIdError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {lastCustomerIdError}
              </p>
            )}

            <label
              htmlFor="email"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Last Customer Id <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="name"
              value={input.postfix}
              onChange={(e) => {
                setInput({
                  ...input,
                  postfix: e.target.value,
                });
                // setPostfixError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {/*postfixError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {postfixError}
              </p>
            )*/}

            <label
              htmlFor="postfix"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Postfix
            </label>
          </FloatLabel>
        </div>

        
      </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreCustomerIdConfigAdd;
